import React from "react";
import * as Yup from "yup";
import { ETLCodes } from "../../locales";
import { useTl } from "../useTl";

export const useValidators = () => {
  const { t } = useTl();

  const dataTranslationValidator = React.useMemo(
    () =>
      Yup.object().shape({
        dataTranslationValues: Yup.array().of(
          Yup.object().shape({
            text: Yup.string()
              .nullable()
              .when("languageCode", {
                is: "EN",
                then: (schema) => schema.required(t(ETLCodes.Required)),
                otherwise: (schema) => schema,
              }),
          })
        ),
      }),
    [t]
  );

  return {
    dataTranslationValidator,
  };
};
